"use strict";

exports.__esModule = true;
exports.CLASSIFICATION_SOURCE_UI = void 0;
var CLASSIFICATION_SOURCE_UI = exports.CLASSIFICATION_SOURCE_UI = "ui";